<script>
import NavBar from 'comp/NavBar.vue'
import Corporate from 'comp/common/Corporate'
// import VideoCover from 'comp/common/VideoPlayer/VideoCover.vue'
// import Buttonbg from 'comp/content/Button/Buttonbg.vue'

const DialogCommon = resolve => {
  import('comp/content/Dialog/DialogCommon.vue').then(module => resolve(module))
}
const Search = resolve => {
  import('comp/Search/index.vue').then(module => resolve(module))
}

import { mapGetters } from 'vuex'
import { themeConfigureImgUrl } from '@/utils/common'
import { getSwiperList, recordingPageOpen, recordingPageOff, getVersionApi } from '@/api/config'

// import $ from 'jquery'

const VUE_APP_VERSION = require('../package.json').version

export default {
  components: { NavBar, Corporate, DialogCommon, Search }, //  VideoCover, Buttonbg,
  data () {
    return {
      path: '',
      coverList: [],
      timer: null,
      currentTime: new Date().getTime(),
      imageCoverTimeOut: 1000 * 60 * 5,
      coverSwiperFlag: true,
      screenSize: 1,
      navbarIsShow: true,
      navbarList: [],
      village: localStorage.getItem('currentCommunity') || '',
      powerUpTimer: null,
      vers: '',
      videoList: [],
      // 'https://partyhelp.cdjsc.com.cn/mp4/79e182b8-8f9a-4ee3-bcee-f7f020b1feed.mp4',
      // 'https://partyhelp.cdjsc.com.cn/mp4/16sd8w6e15sdb8rr61sws6.mp4',
      // 'https://partyhelp.cdjsc.com.cn/mp4/6sd5g1xc85bs6er5df5sb6gd.mp4'
      curVideoIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      navListGetter: 'config/getNavList',
      currentPageTitle: 'config/getCurrentPageTitle',
      currentPageTitleId: 'config/getCurrentPageTitleId',
      theme: 'config/getThemeObj',
      canIuse: 'config/getCanIuse',
      dialogIsShowDepository: 'config/getDialogIsShow',
      getFilePreviewShow: 'config/getFilePreviewShow',
      imageCoverShow: 'coverConfig/getImageCoverShow'
      // videoCoverShow: 'coverConfig/getVideoCoverShow'
    }),
    dialogIsShow: {
      get() {
        return this.dialogIsShowDepository
      }
    },
    navListData() {
      return this.navListGetter
    },
    currentNavTitle() {
      return this.currentPageTitle
    },
    currentNavTitleId() {
      return this.currentPageTitleId
    },
    themeObj() {
      return this.theme
    },
    searchBgImg() {
      const searchBg = this.themeObj?.searchBg || ''
      return searchBg ? themeConfigureImgUrl(searchBg) : require('imgs/search-bg.png')
    },
    isNotInFrame() {
      return this.$route.meta.isNotInFrame
    },
    hasCoverSwiper() {
      const whiteList = ['/peopleCongress20', '/partyLiving', '/partyLivingM3U8', '/dataStatistics', '/partyBuildingDetail', '/filePrev']
      return !whiteList.includes(this.path)
    }
  },
  watch: {
    $route(to, from) {
      this.path = to.path
      // page not in frame, reset store page
      if (this.isNotInFrame) {
        const { templateName = '', id = 0 } = this.navbarList[0]
        this.$store.commit('config/SET_CURRENT_TITLE', templateName)
        this.$store.commit('config/SET_CURRENT_TITLE_ID', id)
      }
      // reset dialog state
      if (to.name !== from.name) {
        this.$store.commit('config/SET_DIALOG', false)
        this.$store.commit('config/SET_CURRENT_MODALNAME', '')
        this.$store.commit('config/SET_CURRENT_MODULE_ID', 0)
        // this.$store.dispatch('subpageConfigure/resetComponentConfigure')
      }
    },
    navListData: {
      handler(newVal) {
        this.navbarList = newVal
      },
      immediate: true
    },
    currentTime(newVal, oldVal) {
      if (newVal - this.$store.state.lastTime > this.imageCoverTimeOut) {
        this.$store.commit('coverConfig/SET_IMAGE_COVER_SHOW', true)
        this.coverSwiperFlag = false
        this.$store.commit('UPDATE_LASTTIME')
      }
    },
    dialogIsShow(newVal, oldVal) {
      newVal ? this.stopScroll() : this.moveScroll()
      if (!newVal) this.$store.dispatch('subpageConfigure/resetComponentConfigure')
    }
    // videoCoverShow: {
    //   handler(v) {
    //     if (!v) {
    //       this.videoList.length && this.videoList.forEach((item, idx) => {
    //         this.$nextTick(() => {
    //           const video = this.$refs[`videoCover${idx}`][0].$refs.videoCover
    //           if (video) {
    //             video.pause()
    //             video.currentTime = 0
    //           }
    //         })
    //       })
    //     }
    //   },
    //   immediate: true
    // }
  },
  beforeCreate() {
    // eslint-disable-next-line no-unused-vars
    let imgCount = 0
    const imgs = [
      require('imgs/partyTop/atlas-bg.webp'),
      require('imgs/partyTop/atlas-detail-bg.webp'),
      require('imgs/partyTop/book-page-bg.webp')
    ]
    for (const img of imgs) {
      let image = new Image()
      image.src = img
      image.onload = () => imgCount++
    }
  },
  created() {
    this.getVersion()
    this.getSwiperData()
    this.$store.commit('UPDATE_LASTTIME')
    const vm = this
    vm.timer = setInterval(() => {
      vm.currentTime = new Date().getTime()
    }, 1000)
    this.recordingPageOpen()
  },
  mounted() {
    this.powerUpTimer = setInterval(() => {
      this.recordingPageOffReq()
    }, 1 * 60 * 1000)

    let beginTime = 0 // 开始时间
    let differTime = 0 // 时间差
    window.onunload = function () {
      differTime = new Date().getTime() - beginTime
      if (differTime <= 5) {
        console.log('close page')
        window.onbeforeunload = function (e) {
          window.localStorage.removeItem('power-up')
        }
      } else console.log('refresh page')
    }

    window.onbeforeunload = function () {
      beginTime = new Date().getTime()
    }

    // set default value
    // setTimeout(() => {
    //   this.$store.commit('config/SET_CURRENT_TITLE', '居务公开')
    //   this.$store.commit('config/SET_CURRENT_TITLE_ID', 269)
    // }, 2000)
    // setTimeout(() => {
    //   const configure = { id: 7, titleid: 2472, typeid: 0, title: '惠民政策对象公示', subtitle: '' }
    //   this.$store.commit('subpageConfigure/SET_COMPONENT_CONFIGURE', configure)
    //   const dataConfigure = { id: 0, headline: '惠农政策类' }
    //   this.$store.commit('subpageConfigure/SET_COMPONENT_DATA_CONFIGURE', dataConfigure)

    //   this.$store.commit('config/SET_CURRENT_MODALNAME', configure.title)
    //   this.$store.commit('config/SET_CURRENT_MODULE_ID', configure.id)
    //   const whiteList = [15, 61, 66]
    //   if (whiteList.includes(configure.id)) return
    //   this.$store.commit('config/SET_DIALOG', true)
    // }, 4000)
  },
  beforeDestroy() {
    localStorage.removeItem('power-up')
    clearInterval(this.timer)
    clearInterval(this.powerUpTimer)
  },
  methods: {
    themeConfigureImgUrl,
    getVersion() {
      getVersionApi({ status: 1 }).then(res => {
        this.vers = res?.msg?.[0]?.frontendversion || VUE_APP_VERSION
        const storageVers = window.localStorage.getItem('Version') || ''
        if (!storageVers) {
          window.localStorage.setItem('Version', this.vers)
          return
        }
        if (this.vers !== storageVers) {
          this.$confirm('发现系统版本更新, 请刷新页面后使用。', '版本更新提示', {
            showClose: false,
            showCancelButton: false,
            closeOnClickModal: false
          }).then(() => {
            window.localStorage.removeItem('power-up')
            window.localStorage.setItem('Version', this.vers)
            location.reload()
          })
        }
      })
    },
    onReturn() {
      window.location.href = 'https://hyadmin.djplus.cn/hyPartyBuildEntry'
    },
    recordingPageOpen() {
      const params = { id: localStorage.getItem('power-up') || 0, village: this.village }
      recordingPageOpen(params).then(res => {
        if (res.code === 0) localStorage.setItem('power-up', res.count)
      })
    },
    recordingPageOffReq() {
      const params = { id: localStorage.getItem('power-up') || 0, village: this.village }
      recordingPageOff(params)
    },

    getSwiperData() {
      getSwiperList().then(res => {
        if (res.code === 0) {
          this.coverList = res?.msg || []

          this.stopLoadingAnimation()
        } else {
          this.stopLoadingAnimation()
        }
      })
    },
    // 停止loading动画
    stopLoadingAnimation () {
      setTimeout(() => {
        const loadingEl = document.getElementById('initial-loading')
        if (loadingEl) {
          loadingEl.style.display = 'none'
        }
      }, 1000)
    },
    moveEvent() { // has event
      this.$store.commit('coverConfig/SET_IMAGE_COVER_SHOW', false)
      this.coverSwiperFlag = false
      this.$store.commit('UPDATE_LASTTIME')
    },
    handleNavClickFn({ title, id }) {
      this.$store.commit('config/SET_CURRENT_TITLE', title)
      this.$store.commit('config/SET_CURRENT_TITLE_ID', id)
    },
    handleScrollLeft() {
      this.toggleHandler('left')
    },
    handleScrollRight() {
      this.toggleHandler('right')
    },
    toggleHandler(arrow) {
      if (this.getFilePreviewShow || this.dialogIsShowDepository) return
      const arrowVal = arrow === 'left' ? 1 : -1
      setTimeout(() => {
        this.$store.commit('config/SET_CURRENT_MODALNAME', '')
        this.$store.commit('config/SET_CURRENT_MODULE_ID', 0)
        this.$store.commit('config/SET_DIALOG', false)
      }, 10)
      try {
        this.navListData.forEach((item, idx) => {
          if (this.currentNavTitle === item.templateName && this.currentNavTitleId === item.id) {
            const { templateName: setNameVal, id: setNameValId } = this.navListData[idx + arrowVal]
            // const setNameVal = this.navListData[idx + arrowVal].templateName
            // const setNameValId = this.navListData[idx + arrowVal].id
            if (setNameVal && setNameValId) {
              this.$store.commit('config/SET_CURRENT_TITLE', setNameVal)
              this.$store.commit('config/SET_CURRENT_TITLE_ID', setNameValId)
            }
            throw new Error('EndIterative')
          }
        })
      } catch (e) {
        if (e.message === 'EndIterative') console.log('EndIterative')
      }
    },
    handleScreen(type) {
      if (type === 'enlarge' && this.screenSize < 3) this.screenSize += 1
      if (type === 'narrow' && this.screenSize > 1) this.screenSize -= 1
      let scale = 1
      switch (this.screenSize) {
        case 1: scale = 1
          break
        case 2: scale = 1.2
          break
        case 3: scale = 1.4
          break
      }
      this.$store.commit('config/SET_SCREEN_SIZE', scale)
    },
    closeNavbar() {
      this.navbarIsShow = false
    },

    // stop scroll when dialog is show
    stopScroll() {
      var mo = function(e) { e.preventDefault() }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    moveScroll() {
      var mo = function(e) { e.preventDefault() }
      document.body.style.overflow = ''
      document.removeEventListener('touchmove', mo, false)
    },

    toHometownAtlas() {
      this.$router.push('/hometownAtlas')
    },
    handlePaste(e) { // no right click
      e.preventDefault()
      return false
    },
    openSearch() {
      this.$store.commit('config/SET_DIALOG_COMMON', true)
    },
    // video cover
    swipedown() {
      if (!this.videoList.length) return
      this.$refs.videoCoverCarouselRef.setActiveItem(0)
      this.$refs.videoCover0[0].$refs.videoCover.play()
      this.$store.commit('coverConfig/SET_VIDEO_COVER_SHOW', true)
      // this.getVideoPlayStatus()
    },
    onvideoCoverSwipeup() {
      // this.videoList.forEach((item, idx) => {
      //   const video = this.$refs[`videoCover${idx}`][0].$refs.videoCover
      //   video.pause()
      //   video.currentTime = 0
      // })
      this.$store.commit('coverConfig/SET_VIDEO_COVER_SHOW', false)
      // this.getVideoPlayStatus()
    },
    onVideoCoverChange(index) {
      this.curVideoIndex = index
      this.videoList.forEach((item, idx) => {
        if (index !== idx) {
          const video = this.$refs[`videoCover${idx}`][0].$refs.videoCover
          video.pause()
          video.currentTime = 0
        }
      })
      this.$refs[`videoCover${index}`][0].$refs.videoCover.play()
      // this.getVideoPlayStatus()
    },
    ontimeupdate({ duration, currentTime }) {
      if (duration - currentTime < 0.5) this.$refs.videoCoverCarouselRef.next()
    },
    getVideoPlayStatus() {
      setTimeout(() => {
        const domList = []
        this.videoList.forEach((item, idx) => {
          domList.push(this.$refs[`videoCover${idx}`][0].$refs.videoCover.paused ? 'paused' : 'playing')
        })
        console.log(domList)
      }, 100)
    }
  }
}
</script>

<template>
  <div class="app-container" @contextmenu="handlePaste($event)"><!-- 这一层禁止大屏网页随意拖动 -->
    <!-- :class="{'set-grey': path === '/communityIntro'}" -->
    <div
      class="app"
      :class="{'party-top': isNotInFrame}"
      :style="{
        background: `url(${!isNotInFrame ? themeConfigureImgUrl(themeObj.mainBg) : ''}) no-repeat center`,
        backgroundSize: '100% 100%'
      }"
      @mousemove="moveEvent"
      @click="moveEvent"
    >
      <!-- <v-touch class="video_cover_touch" :class="{'video_cover_touch--hidden': !videoCoverShow}" @swipeup="onvideoCoverSwipeup">
        <div class="video_swiper_cover">
          <el-carousel
            ref="videoCoverCarouselRef"
            height="100%"
            arrow="never"
            :autoplay="false"
            @change="onVideoCoverChange"
          >
            <el-carousel-item v-for="(v, i) in videoList" :key="v">
              <div class="video_bg">
                <VideoCover :ref="`videoCover${i}`" :video-url="v" @ontimeupdate="ontimeupdate" />
              </div>
            </el-carousel-item>
          </el-carousel>
          <Buttonbg class="video_swiper_button" @click="onvideoCoverSwipeup">回到首页</Buttonbg>
        </div>
      </v-touch> -->
      <p v-if="['青杠坪村', '测试社区'].includes(village)" class="isHyEntry" @click="onReturn">返回</p>
      <!-- <p class="search" @click="openSearch"><i class="el-icon-search" /> search</p> -->
      <router-view v-if="isNotInFrame" />

      <v-touch
        v-if="!isNotInFrame"
        class="touch-box"
        @swipeleft="handleScrollLeft"
        @swiperight="handleScrollRight"
        @swipedown="swipedown"
      >
        <div
          class="router-view"
          :class="{'translate': !navbarIsShow}"
          :style="{
            background: `url(${themeConfigureImgUrl(themeObj.viewFrameBg)}) no-repeat center`,
            backgroundSize: '100% 100%'
          }"
        >
          <Transition name="fade-transform" mode="out-in">
            <!-- <router-view /> -->
            <router-view :key="$route.fullPath" />
          </Transition>
          <div class="screen-operation">
            <div
              class="search-box"
              :style="{background: `url('${searchBgImg}') no-repeat center`}"
              @click="openSearch"
            >搜索</div>
            <!-- :src="require('imgs/enlarge.png')" require('imgs/narrow.png')" -->
            <img class="operation-img" :src="themeConfigureImgUrl(themeObj.enlarge)" alt="enlarge" @click="handleScreen('enlarge')">
            <img class="operation-img" :src="themeConfigureImgUrl(themeObj.narrow)" alt="narrow" @click="handleScreen('narrow')">
          </div>
        </div>
      </v-touch>
      <!-- <v-touch class="touch-box" @swipeleft="handleScrollLeft" @swiperight="handleScrollRight">
    </v-touch> -->

      <div v-if="!isNotInFrame">
        <Transition name="navbar-transfrom" mode="out-in">
          <NavBar
            v-show="navbarIsShow"
            class="nav-bar"
            @handleNavClickFn="handleNavClickFn"
            @closeNavbar="closeNavbar"
          />
        </Transition>
      </div>

      <Transition name="open-nav-img">
        <!-- :src="require('imgs/open-nav.webp')" -->
        <img
          v-show="!navbarIsShow"
          class="open-nav"
          :src="themeConfigureImgUrl(themeObj.openNav)"
          alt="open-nav"
          @click="navbarIsShow = true"
        >
      </Transition>
      <!--  && !videoCoverShow -->
      <div v-if="((imageCoverShow || coverSwiperFlag) && canIuse && hasCoverSwiper)" class="cover-swiper">
        <el-carousel height="100%" indicator-position="none" arrow="never" :interval="10000">
          <el-carousel-item v-for="(v, i) in coverList" :key="`swiper-item-${i}`">
            <div class="carousel-box">
              <el-image class="cover-img" :src="v.img | imgPath" alt="" fit="cover" />
              <!-- <div v-if="v.id === 9" class="atlas">
                <div class="atlas-logo-box">
                  <el-image class="atlas-logo" :src="require('imgs/plant.png')" alt="plant" />
                </div>
                <p class="atlas-text" @click="toHometownAtlas">党的二十大，图说洪雅变化</p>
              </div> -->
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div v-if="!canIuse" class="no-service">
        <el-image class="no-service-img" :src="require('imgs/no-service.png')" alt="no-service" />
      </div>
      <div v-if="path === '/communityIntro'" class="corporate-container">
        <Corporate class="corporate-comp" />
        <p class="version">v{{ vers }}</p>
      </div>

      <dialog-common>
        <template><Search /></template>
      </dialog-common>
    </div>
  </div>
</template>

<style lang="scss">
@import './styles/normalize.css';
@import './styles/common.scss';
@import './styles/modules.scss';

.app-container {
  position: fixed;
  width: 100%;
  min-height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.version {
  font-size: 15px;
  color: #fff;
  text-shadow: 0 0 5px #000;
  transform: translate(20px, 4px);
}
.app {
  width: 100%;
  min-height: 100vh;
  background-size: 100% 100% !important;
  padding: 50px 0 0 110px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  z-index: -3;
  .video_cover_touch {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transform: translateY(0);
    transition: all .4s ease-in-out;
  }
  .video_cover_touch--hidden {
    transform: translateY(-1200px);
  }
  .video_swiper_cover {
    width: 100%;
    height: 100%;
    .video_bg {
      width: 100%;
      height: 100%;
    }
    .video_swiper_button {
      position: absolute;
      bottom: 125px;
      left: -2px;
      z-index: 2;
    }
  }
  .isHyEntry {
    position: absolute;
    left: 0;
    bottom: 20px;
    font-size: 18px;
    color: #999;
    cursor: pointer;
  }
  .search {
    position: absolute;
    left: 0;
    top: 800px;
    cursor: pointer;
  }
  .data-statistics {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
  .corporate-container {
    position: absolute;
    bottom: 10px;
    width: 1618px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.party-top {
  padding: 0;
  height: 100%;
}

.nav-bar {
  position: absolute;
  top: 453px;
  right: 0;
}

.open-nav {
  position: absolute;
  right: 0;
  top: 623px;
  width: 60px;
  height: 187px;
  cursor: pointer;
}

.touch-box {
  width: 1618px;
  height: 980px;
  margin-bottom: 40px;
}

.router-view {
  width: 1618px;
  height: 980px;
  position: relative;
  transition: all linear .2s;
  background-size: 100% 100% !important;
  display: grid;
  place-items: center;
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  // filter: drop-shadow(rgba(149, 157, 165, 0.2) 0px 8px 24px);
  .screen-operation {
    position: absolute;
    right: -33px;
    top: 275px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .search-box {
      position: absolute;
      top: -38px;
      width: 34px;
      height: 48px;
      // background: url('~imgs/search-bg.png') no-repeat center;
      background-size: 100% 100% !important;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      writing-mode: vertical-lr;
      letter-spacing: 2px;
      display: grid;
      place-items: center;
      cursor: pointer;
    }
    .operation-img {
      width: 34px;
      height: 57px;
      cursor: pointer;
    }
  }
}
.translate {
  transform: translateX(43px);
}

.cover-swiper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  .carousel-box {
    width: 100%;
    height: 100%;
    position: relative;
    .cover-img {
      width: 100%;
      height: 100%;
    }
    .atlas {
      position: absolute;
      top: 628px;
      left: 1298px;
      display: flex;
      align-items: center;
      column-gap: 11px;
      .atlas-logo-box {
        width: 61px;
        height: 61px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, .3);
        border-radius: 50%;
        .atlas-logo {
          width: 39px;
          height: 39px;
        }
      }
      .atlas-text {
        width: 316px;
        height: 61px;
        background-color: rgba(0, 0, 0, .3);
        border-radius: 31px;
        text-align: center;
        line-height: 61px;
        cursor: pointer;

        font-size: 21px;
        font-weight: bold;
        text-decoration: underline;
        color: #fff;
      }
    }
  }
}

.no-service {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  .no-service-img {
    width: 1270px;
    height: 606px;
  }
}
</style>

<style lang="scss">
.set-grey {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  //-ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}
.cover-swiper, .video_swiper_cover {
  .el-carousel {
    width: 100%;
    height: 100% !important;
  }
}
</style>
